/* eslint-disable jsx-a11y/no-access-key */
import React from 'react'
import { useTranslation } from 'react-i18next'
import config from '../../../../config'
import { FormControl, Input, MenuItem, Select, useTheme } from '@material-ui/core'
import { useSelector } from 'react-redux'
import BenchmarkSelector from '../../BenchmarkSelector'
import { handlePromptValueToggle } from '../../../../utils'
import { KeyboardArrowDown } from '@material-ui/icons'
import RagRecommendations from './RagRecommendations'

const RightSection = ({
  aiSelectWrapperRef,
  benchmarkSelectWrapperRef,
  benchmarkList,
  useBenchmarkList,
  taskTypesList,
  useModel,
  handleOnModelChange,
  currentCard,
  handleTextTypeChange,
  promptForOptimization,
  setPromptForOptimization,
  setPromptValues,
  promptValues,
  handleOurAi,
  translatedText,
  mainEditorText,
  contextFragments,
  setContextFragments
}) => {
  const { t} = useTranslation()
  const { theme: { bgColors, colors, borderColors } } = useTheme()

  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const isWhite = themeState === config.THEMES_MODES.CONTRAST_LIGHT
  return (
    <div className="col-lg-4 col-md-12" style={{ height: '100%' }}>
      <div className="p-3 pb-5" style={{
        backgroundColor: bgColors.bgPrimary100,
        borderRadius: '8px',
        height: '100%',
        overflowY: 'auto',
        border: `1px solid ${borderColors.borderPrimary200}`,
      }}>
        <h6 className="fw-bold mb-3" style={{ color: colors.colorText }}>{t('ai_gen_basic-settings')}</h6>
        <div>
          <div className="d-flex align-items-start justify-content-between" style={{ gap: '0.75rem' }}>
            <div style={{ width: '50%' }} ref={aiSelectWrapperRef}>
              <div id="ai-gen-model-label" style={{
                whiteSpace: 'nowrap',
                fontSize: '0.95rem',
                fontWeight: 'bold',
                color: isContrast ? colors.colorText : colors.colorIntermediateText,
                marginBottom: '0.5rem'
              }}>
                {t('ai_gen_select_model')}
              </div>
              <FormControl
                variant="standard"
                fullWidth
                style={{
                  backgroundColor: bgColors.bgPrimary600,
                  border: 'none',
                  borderRadius: 4,
                  height: 30,
                  justifyContent: 'center',
                  padding: '0 8px'
                }}
                tabIndex={config.tabIndexes.aiSelectAi}
              >
                <span id="ai-gen-model-select-label" className="sr-only" style={{
                  backgroundColor: bgColors.bgPrimary0,
                  color: colors.colorText
                }}>{t('ai_gen_select_model')}</span>
                <Select
                  disableUnderline
                  IconComponent={props => (
                    <KeyboardArrowDown {...props} style={{ color: colors.colorPrimary50 }}/>
                  )}
                  className="font-weight-bold"
                  style={{ color: colors.colorPrimary50, fontSize: '0.875rem' }}
                  value={useModel}
                  onChange={handleOnModelChange}
                  inputProps={{
                    'aria-labelledby': 'ai-gen-model-select-label',
                    id: 'ai-gen-model-select',
                    style: {
                      color: colors.colorPrimary50,
                      fontWeight: 'bold',
                      fontSize: '0.875rem',
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        backgroundColor: bgColors.bgPrimary600,
                        color: colors.colorPrimary50,
                      },
                    },
                  }}
                >
                  {Object.keys(taskTypesList).map(key => (
                    <MenuItem key={key} value={key} style={{ display: 'flex', alignItems: 'center' }}>
                      <span>{t(key)}</span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <div style={{ width: '50%' }} ref={benchmarkSelectWrapperRef}>
              <div id="ai-gen-text-type-label" style={{
                whiteSpace: 'nowrap',
                fontSize: '0.95rem',
                fontWeight: 'bold',
                color: isContrast ? colors.colorText : colors.colorIntermediateText,
                marginBottom: '0.5rem'
              }}>
                {t('ai_gen_select_task_type')}
              </div>
              <FormControl
                variant="outlined"
                fullWidth
                style={{
                  backgroundColor: bgColors.bgPrimary600,
                  borderRadius: 4,
                  height: 30,
                  justifyContent: 'center',
                }} tabIndex={config.tabIndexes.genTextTypeSelect}
              >
                <BenchmarkSelector
                  benchmarkList={benchmarkList}
                  useBenchmarkList={useBenchmarkList}
                  handleOnTextTypeChange={handleTextTypeChange}
                  accessKey={config.accessKeys.benchmarkSelectionTop}
                  ariaLabel={t('ai_gen_select_task-type')}
                  labelId="ai-gen-task-type-label"
                  styleMain={{
                    color: colors.colorPrimary50,
                    fontSize: '0.875rem',
                    height: '100%',
                    fontWeight: 'bold',
                  }}
                  stylePaper={{
                    backgroundColor: bgColors.bgPrimary600,
                    color: colors.colorPrimary50
                  }}
                  styleArrow={{ color: colors.colorPrimary50 }}
                />
              </FormControl>
            </div>
          </div>
          <hr className="mt-4" style={{ borderTop: `1px solid ${borderColors.borderPrimary200}` }}/>
        </div>
        <div>
          <label className="font-weight-bold small m-0 mb-2"
                 style={{ color: colors.colorText }} htmlFor="ai-gen-optimization-input" id="ai-gen-optimization-input-label">{t('ai_gen_prompt')}</label>
          <FormControl fullWidth style={{
            flex: 1,
            border: `1px solid ${borderColors.borderPrimary200}`,
            backgroundColor: bgColors.bgPrimary0,
            borderRadius: '7px',
            padding: '0 10px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
          }}>
            <Input
              placeholder={t('ai_gen_optimization-placeholder')}
              multiline
              rows="4"
              value={promptForOptimization}
              onChange={(e) => {
                setPromptForOptimization(e.target.value)
              }}
              disableUnderline
              inputProps={{
                id: 'ai-gen-optimization-input',
                'aria-labelledby': 'ai-gen-optimization-input-label',
                accessKey: config.accessKeys.genOptInput,
                tabIndex: config.tabIndexes.genOptInput,
                style: {
                  color: colors.colorText,
                }
              }}
            />
          </FormControl>
          <hr className="my-4" style={{ borderTop: `1px solid ${borderColors.borderPrimary200}` }}/>
        </div>
        <div className="row">
          {Array.isArray(currentCard?.shared_settings?.optimization?.settings) && currentCard.shared_settings.optimization.settings.map((setting, settIndex) => (
            <div className="col-12 mb-2" key={setting.name}>
              <label className="font-weight-bold small d-block mb-2"
                     style={{ color: colors.colorText }}>{t(setting.name)}</label>
              <div className="d-flex flex-wrap" style={{ gap: '0.5rem' }}>
                {setting.values.map((value, valIndex) => {
                  const isSelected = promptValues[setting.name] === value.id
                  const flatIndex = currentCard.shared_settings.optimization.settings
                    .slice(0, settIndex)
                    .reduce((acc, s) => acc + s.values.length, 0) + valIndex
                  return (
                    <div onClick={() => setPromptValues(prev => handlePromptValueToggle(prev, setting.name, value.id))}
                         tabIndex={config.tabIndexes.genSelections[flatIndex] ?? -1}>
                      <button key={value.id} type="button"
                              className={`btn px-2 py-1 ${isSelected ? 'text-white' : ''}`} style={{
                        backgroundColor: isSelected ? bgColors.bgAiBtnSelected : bgColors.bgAiBtn,
                        color: isSelected ? colors.colorWhite : isWhite ? colors.colorWhite : isContrast ? colors.colorText : colors.colorMutedText,
                        fontSize: '0.75rem',
                        transition: 'background-color 0.2s ease, color 0.2s ease',
                        boxShadow: isSelected ? '0 0 5px rgba(0, 0, 0, 0.161)' : 'none',
                        border: isSelected ? `1px solid ${borderColors.borderPrimary200}` : 'none'
                      }}
                              onMouseEnter={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.backgroundColor = bgColors.bgAiBtnHover
                                  e.currentTarget.style.color = colors.colorWhite
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.backgroundColor = bgColors.bgAiBtn
                                  e.currentTarget.style.color = isWhite ? colors.colorWhite : isContrast ? colors.colorText : colors.colorMutedText
                                }
                              }}>
                        {t(value.text)}
                      </button>
                    </div>
                  )
                })}
              </div>
            </div>
          ))}
        </div>
        <hr className="my-4 pb-2" style={{ borderTop: `1px solid ${borderColors.borderPrimary200}` }}/>
        <div onClick={() => { handleOurAi(translatedText, true) }} tabIndex={config.tabIndexes.genOptBtn}
             className="w-100 d-flex justify-content-center align-items-center">
          <button className="btn" style={{
            backgroundColor: bgColors.bgProgress100,
            color: colors.colorBtnText,
            borderRadius: '8px',
            border: `1px solid ${borderColors.borderPrimary200}`
          }} title={t('ai_gen_optimization_button')} accessKey={config.accessKeys.genOptimize}>
            {t('ai_gen_optimization_button')}
          </button>
        </div>
        <RagRecommendations
          mainEditorText={mainEditorText}
          contextFragments={contextFragments}
          setContextFragments={setContextFragments}
        />
      </div>
    </div>
  )
}

export default RightSection